<template>
  <section class="lista-parceiros" v-if="alliance">
    <input 
      v-model="busca"
      type="text"
      placeholder="Buscar parceiro..."
      class="input-busca"
    />

    <div v-for="parceiro in listaPaginada" :key="parceiro.id" class="parceiro-item">
      
      <img
        class="img-parceiro"
        :src="parceiro.imagens.length
              ? `${urldaImg}${parceiro.imagens[0].url}`
              : require('@/assets/placeholder-image.jpg')"
        :alt="parceiro.nome"
      />


      <div class="parceiro-info">
        <h3>{{ parceiro.nome }}</h3>
        <p class="line-clamp-3">{{ parceiro.descricao }}</p>

        <p><span class="font-bold">Site: </span> {{ parceiro.site }}</p>
        <p><span class="font-bold">Lista: </span>{{ parceiro.lista }}</p>
        <p><span class="font-bold">Local: </span>{{ parceiro.local }}</p>
        <p><span class="font-bold">E-mail: </span>{{ parceiro.email }}</p>
        <p><span class="font-bold">Telefone: </span>{{ parceiro.telefone }}</p>
        <p>
          <span class="font-bold">Redes Sociais: </span>
          <ul v-for="rede in parceiro.redes" :key="rede.id">
            <li><span>{{ rede.nome }}</span>: {{ rede.endereco }}</li>
          </ul>
        </p>
        <p class="text-sm">
          <span :class="{ Ativo: parceiro.status, Inativo: !parceiro.status }">
            {{ status(parceiro.status) }}
          </span>
        </p>
        <p class="text-sm">
          <span class="font-bold">Criado em: </span
          >{{ formatarData(parceiro.created_at) }}
        </p>
        <p class="text-sm">
          <span class="font-bold">Ultima Atualização: </span
          >{{ formatarData(parceiro.updated_at) }}
        </p>
        <p class="text-sm">
          Atualizado por: {{ formatarData(parceiro.responsavel_update) }}
        </p>
        <div class="mt-6">
          <button 
            class="bg-gray-700 text-white px-2 py-1 rounded"
            @click="editar(parceiro)"
          >
            Editar
          </button>
        </div>
      </div>
    </div>
    <edit-parceiro-modal
      v-if="modalAberto"
      :parceiro="parceiroSelecionado"
      @close="modalAberto = false"
      @salvar="salvarEdicao"
    />
    <div class="paginacao" v-if="totalPaginas > 1">
      <!-- Voltar -->
      <button 
        :disabled="paginaAtual === 1" 
        @click="irParaPagina(paginaAtual - 1)"
      >
        ‹ Anterior
      </button>

      <!-- Números -->
      <button 
        v-for="p in totalPaginas" 
        :key="p"
        @click="irParaPagina(p)"
        :class="{ ativo: paginaAtual === p }"
      >
        {{ p }}
      </button>

      <!-- Avançar -->
      <button 
        :disabled="paginaAtual === totalPaginas" 
        @click="irParaPagina(paginaAtual + 1)"
      >
        Próxima ›
      </button>

    </div>

  </section>
</template>

<script>
import { formatarData } from '@/services/services.js';
import EditParceiroModal from '@/components/EditParceiroModal.vue';
import { api } from '@/services/services';
import { urlImg } from '@/services/services';


export default {
  name: 'AllianceItem',
  data(){
    return {
      urldaImg: urlImg,
      modalAberto: false,
      parceiroSelecionado: null,
      paginaAtual: 1,
      itensPorPagina: 4,
      busca: ""
    }
  },
  components: {EditParceiroModal},
  methods: {
    editar(parceiro) {
      this.parceiroSelecionado = parceiro;
      this.modalAberto = true;
    },
    irParaPagina(p) {
      this.paginaAtual = p;
      // sobe pro topo
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    async salvarEdicao(dados) {
      const formData = new FormData();

      // Campos simples
      formData.append("nome", dados.nome);
      formData.append("descricao", dados.descricao);
      formData.append("descricao_en", dados.descricao_en);
      formData.append("site", dados.site);
      formData.append("email", dados.email);
      formData.append("telefone", dados.telefone);
      formData.append("lista", dados.lista);
      formData.append("local", dados.local);
      formData.append("status", dados.status ? 1 : 0);

      formData.append("responsavel_update", this.usuario.nome);

      // Redes editadas / novas
      dados.redes.forEach((rede, index) => {
        formData.append(`redes[${index}][id]`, rede.id ?? "");
        formData.append(`redes[${index}][nome]`, rede.nome);
        formData.append(`redes[${index}][endereco]`, rede.endereco);
      });

      // Redes removidas
      if (dados.redesRemovidas) {
        dados.redesRemovidas.forEach(id => {
          formData.append('redesRemovidas[]', id);
        });
      }

      // IDs de imagens removidas
      dados.imagensRemovidas.forEach(id => {
        formData.append('imagensRemovidas[]', id);
      });

      // Novas imagens
      dados.novasImagens.forEach(file => {
        formData.append('novasImagens[]', file);
      });

      try {
        
        const response = await api.post(`alliances/atualiza/${dados.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        });

        // Toast de sucesso (se existir mensagem no backend)
        this.$toast.success({
          title: "Sucesso",
          message: response.data.message || "Atualização realizada com sucesso!",
          position: "bottomRight",
        });
        
        this.$store.dispatch("fetchAlliances");
        console.log(response.data.error);

      } catch(error){
        const msg = error.response.data.error
        this.$toast.error({
          title: "Erro",
          message: msg || "Falha ao tentar atualizar o parceiro!",
          position: "bottomRight",
        });
      }
    },
    status(value) {
      return value ? 'Ativo' : 'Inativo';
    },
    formatarData,
  },
  computed: {
    alliance() {
      return this.$store.state.alliances
        ? [...this.$store.state.alliances].sort(
            (a, b) => a.ordem_exibicao - b.ordem_exibicao
          )
        : [];
    },
    filteredAlliance() {
      if (!this.busca) return this.alliance;

      const termo = this.busca.toLowerCase();

      return this.alliance.filter(parceiro =>
        parceiro.nome.toLowerCase().includes(termo) ||
        parceiro.descricao?.toLowerCase().includes(termo) ||
        parceiro.lista.toLowerCase().includes(termo) ||
        parceiro.local.toLowerCase().includes(termo) ||
        parceiro.email.toLowerCase().includes(termo)
      );
    },
    usuario() {
      return this.$store.state.usuario;
    },
    totalPaginas() {
      return Math.ceil(this.filteredAlliance.length / this.itensPorPagina);
    },
    listaPaginada() {
      const start = (this.paginaAtual - 1) * this.itensPorPagina;
      return this.filteredAlliance.slice(start, start + this.itensPorPagina);
    }
  },
  watch: {
    busca() {
      this.paginaAtual = 1;
    }
  }


};
</script>

<style scoped>
.lista-parceiros {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.parceiro-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  border-bottom: 1px solid #ddd;
}

.img-parceiro {
  width: 150px;
  min-width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
}

.parceiro-info h3 {
  margin: 0;
  font-size: 1.2rem;
}

.parceiro-info p {
  margin: 5px 0 0 0;
  color: #666;
}

@media screen and (max-width: 500px) {
  .alliance {
    gap: 10px;
    margin: 10px;
  }
}

.Ativo {
  background: #4caf50; /* verde */
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
}

.Inativo {
  background: #e53935; /* vermelho */
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
}

/* Paginação */

.paginacao {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.paginacao button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.paginacao button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.paginacao button.ativo {
  background: #333;
  color: #fff;
  font-weight: bold;
}

/* Busca */
.input-busca {
  width: 100%;
  padding: 8px 12px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

@media (max-width: 640px) {
  /* item vira coluna */
  .parceiro-item {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px 0;
  }

  /* imagem ocupa largura */
  .img-parceiro {
    width: 100%;
    min-width: unset;
    height: 180px;
  }

  /* textos mais compactos */
  .parceiro-info h3 {
    font-size: 1.05rem;
  }

  .parceiro-info p {
    font-size: 0.85rem;
    line-height: 1.4;
  }

  /* botão editar confortável pro toque */
  .parceiro-info button {
    width: 100%;
    padding: 8px 0;
  }

  /* paginação quebra linha */
  .paginacao {
    flex-wrap: wrap;
    gap: 6px;
  }

  .paginacao button {
    flex: 1 1 45%;
  }

  /* busca mais confortável */
  .input-busca {
    font-size: 0.9rem;
  }
}
@media (min-width: 641px) and (max-width: 1023px) {
  /* mantém layout lado a lado */
  .parceiro-item {
    align-items: flex-start;
  }

  /* imagem um pouco menor */
  .img-parceiro {
    width: 120px;
    min-width: 120px;
    height: 120px;
  }

  /* melhora leitura */
  .parceiro-info h3 {
    font-size: 1.1rem;
  }

  .parceiro-info p {
    font-size: 0.9rem;
  }

  /* paginação organizada */
  .paginacao {
    gap: 10px;
  }
}

</style>
